import {
  LifecycleStatus,
  lifecycleStatusFromJSON,
  lifecycleStatusToJSON,
} from '@classpass/protobuf-definitions/lib/web/models/partners/sku_order';
import {
  MarkedFulfilledType,
  markedFulfilledTypeToJSON,
  OrderItemCancellationType,
  orderItemCancellationTypeToJSON,
  ProcessingStatus,
  processingStatusToJSON,
} from '@classpass/protobuf-definitions/lib/web/models/shared/orders/sku_order';

/** Strips proto JSON prefixes so FE values match normalizePartnerOrder output (e.g. ACTIVE, DRAFT). */
export const SKU_ORDER_PROTO_ENUM_PREFIX =
  /^(LIFECYCLE_STATUS_|PROCESSING_STATUS_|MARKED_FULFILLED_TYPE_|ORDER_ITEM_CANCELLATION_TYPE_)/;

export const enumToFeString = (value, toJsonFn) => {
  if (value === undefined || value === null) return null;
  const json = typeof value === 'number' ? toJsonFn(value) : value;
  return String(json).replace(SKU_ORDER_PROTO_ENUM_PREFIX, '');
};

/** Named proto enum members (excludes numeric reverse-map keys like "0", "1"). */
export const protoEnumMemberKeys = ProtoEnum =>
  Object.keys(ProtoEnum).filter(key => typeof ProtoEnum[key] === 'number' && !/^-?\d+$/.test(key));

/** Builds { ACTIVE: 'ACTIVE', ... } from generated proto enums — includes every variant (no filtering). */
export const buildFeEnumConstants = (ProtoEnum, toJsonFn) =>
  protoEnumMemberKeys(ProtoEnum).reduce((constants, key) => {
    const feValue = enumToFeString(ProtoEnum[key], toJsonFn);
    constants[feValue] = feValue;
    return constants;
  }, {});

export const LIFECYCLE_STATUS = buildFeEnumConstants(LifecycleStatus, lifecycleStatusToJSON);

export const PROCESSING_STATUS = buildFeEnumConstants(ProcessingStatus, processingStatusToJSON);

export const MARKED_FULFILLED_TYPE = buildFeEnumConstants(MarkedFulfilledType, markedFulfilledTypeToJSON);

export const ORDER_ITEM_CANCELLATION_TYPE = buildFeEnumConstants(
  OrderItemCancellationType,
  orderItemCancellationTypeToJSON
);

export const toFeLifecycleStatus = status => enumToFeString(status, lifecycleStatusToJSON);

export const feLifecycleStatusToProto = feStatus => {
  if (!feStatus || !Object.values(LIFECYCLE_STATUS).includes(feStatus)) return undefined;
  return lifecycleStatusFromJSON(`LIFECYCLE_STATUS_${feStatus}`);
};
